import React from 'react';
import { Box } from '@mui/material';
import { DateInput, CreateForm, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import useEmployeeBackgroundCheckService from 'domain/people/employee/PersonalLegal/backgroundcheck/shared/employeeBackgroundCheckService';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import BackgroundCheckResultDropdown from '../input/BackgroundCheckResultDropdown';
import { BackgroundCheckAttachmentUploaderInput } from 'domain/people/employee/PersonalLegal/backgroundcheck';
import FormActionButtons from 'domain/people/employee/shared/button/showEdit/FormActionButtons';

interface BackgroundCheckCreateFormProps {
  employeeId: string;
  onSave: () => void;
  onCancel: () => void;
}

const BackgroundCheckCreateForm: React.FC<BackgroundCheckCreateFormProps> = ({ employeeId, onSave, onCancel }) => {
  const { getValidationSchema, createBackgroundCheck } = useEmployeeBackgroundCheckService();
  const { addMessage } = useMessageService();

  const handleSubmit = async (formData: any) => {
    try {
      await createBackgroundCheck({
        employeeId,
        ...formData,
      });
      return formData;
    } catch (error) {
      return addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  const FormContent = () => {
    return (
      <Box display="flex" justifyContent="space-between" gap={2}>
        <Box width="100%">
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <DateInput source="performedAt" label="Date" />
            <BackgroundCheckResultDropdown source="result" label="Result" />
          </Box>
          <Box>
            <BackgroundCheckAttachmentUploaderInput source="attachmentsIds" label="Attachments" />
          </Box>
        </Box>
        <Box>
          <FormActionButtons onCancel={onCancel} />
        </Box>
      </Box>
    );
  };

  return (
    <CreateForm
      getValidationSchemaFunc={getValidationSchema}
      submitFormFunc={handleSubmit}
      afterSubmit={{
        execute: onSave,
      }}
    >
      <FormContent />
    </CreateForm>
  );
};

export default BackgroundCheckCreateForm;
